/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { CHANGE_USERNAME, ON_CALL_UPLOAD,ON_SUBMIT_TRUE, SET_ERR_COUNT, SET_PROCESS_COUNT,LOADER_STATUS,PROFILE_INFO, UPLOAD_R2A, FETCH_DATA,RECO_DATA } from './constants';

// The initial state of the App
export const initialState = {
  username: '',
  uploadData: '',
  submitStatus: false,
  errorVal: 0,
  processVal: 0,
  loaderStatus: false,
  profileData: [],
  isR2a:false,
  fetchData: []
};

/* eslint-disable default-case, no-param-reassign */
const dataFetchReducer = (state = initialState, action) =>{
    switch (action.type) {
      case CHANGE_USERNAME:
        return{
          ...state,
          username:action.username.replace(/@/gi, '')
        }
      case ON_CALL_UPLOAD:
        return{
          ...state,
          uploadData:action.uploadData
        }
      case ON_SUBMIT_TRUE:
        return{
          ...state,
          submitStatus:action.submitStatus
        }
      case SET_ERR_COUNT:
        return{
          ...state,
          errorVal:action.errorVal
        }
      case SET_PROCESS_COUNT:
        return{
          ...state,
          processVal:action.processVal
        }
      case LOADER_STATUS:
        return{
          ...state,
          loaderStatus:action.loaderStatus
        }
      case PROFILE_INFO:
        return{
          ...state,
          profileData:action.profileData
        }
      case UPLOAD_R2A:
        return{
          ...state,
          isR2a:action.isR2a
        }    
      case FETCH_DATA:
        return{
          ...state,
          fetchData:action.fetchData
        }
      default:
        return state;  
    }
  };

export default dataFetchReducer;
